export const nicknames = [];
// characters
nicknames.achates = '火奶';
nicknames.aither = '小王子';
nicknames.alencia = '姨妈龙 龙姨妈 姨媽龍 龍姨媽';
nicknames.alexa = '小水刺';
nicknames['all-rounder-wanda'] = '转职汪达 轉職汪達';
nicknames['angelic-montmorancy'] = 'momo 包子头 包包头 小水奶 包子頭 包包頭';
nicknames.angelica = '大水奶 老太婆';
nicknames['apocalypse-ravi'] = '暗罗菲 暗羅菲';
nicknames.aramintha = '火响指 火法 火響指';
nicknames['arbiter-vildred'] = 'arby 暗刺 暗帝 暗25 暗弟弟';
nicknames['ambitious-tywin'] = 'aywin ml.tywin mltywin 光泰温 光泰溫';
nicknames.armin = '木敏 阿敏';
nicknames['assassin-cartuja'] = 'fatcat 暗熊';
nicknames['assassin-cidd'] = 'a.cidd accid 暗席德';
nicknames['assassin-coli'] = 'a.coli acoli 暗可丽 暗可麗';
nicknames['auxiliary-lots'] = 'a.lots alots 暗拉 暗拉兹';
nicknames['adventurer-ras'] = '男主 转职男主 轉職男主';
nicknames['baal-and-sezan'] = '火三眼 火人偶';
nicknames.basar = '埃及佬 木埃及';
nicknames.batisse = '小暗拳';
nicknames.bellona = '木扇';
nicknames['benevolent-romann'] = 'broman 光洛曼';
nicknames['blaze-dingo'] = '光厨子 光廚子';
nicknames['blood-blade-karin'] = 'bbk 血卡';
nicknames['blood-moon-haste'] = '暗正太';
nicknames['briar-witch-iseria'] = '暗飞剑 暗木飞 暗弓 暗飛劍 暗木飛';
nicknames['butcher-corps-inquisitor'] = '哥杀 哥布林杀手 哥殺 哥布林殺手';
nicknames.carmainerose = '火爪';
nicknames.carrot = '卡罗 卡羅';
nicknames.cartuja = '木熊';
nicknames.cecilia = '火龙骑 火龍騎';
nicknames.celeste = '三星光弓';
nicknames['celestial-mercedes'] = '暗女主';
nicknames.celine = '卡琳姨妈 卡琳姨媽';
nicknames.cerise = '水弓';
nicknames.cermia = '夏娜';
nicknames['challenger-dominiel'] = 'c.dom cdom 暗兔';
nicknames['champion-zerato'] = 'c.zerato czerato 暗杰 泥巴佬 泥巴哥 暗傑 杰哥';
nicknames['church-of-ilryos-axe'] = 'axe god axegod 暗斧';
nicknames.charles = '木老头 剑圣 木老頭 劍聖';
nicknames.charlotte = '火呆毛 女王';
nicknames.chloe = '水锤 水錘';
nicknames.cidd = '木席德';
nicknames.clarissa = '水修女';
nicknames.coli = '水可丽 水可麗';
nicknames['commander-lorina'] = '暗枪 暗槍';
nicknames.corvus = '火老头 火老頭';
nicknames['crescent-moon-rin'] = 'ml.rin mlrin 暗02 暗灵儿 暗靈兒';
nicknames['crimson-armin'] = 'c.armin carmin 光亚敏 光猫 光亞敏 光貓';
nicknames.crozet = '团长 團長';
nicknames['dark-corvus'] = 'dc DC 魔神王 暗魔神';
nicknames['desert-jewel-basar'] = 'dj.basar djbasar 光埃及';
nicknames.destina = '木奶';
nicknames.diene = '圣女 聖女';
nicknames.dingo = '火厨子 火廚子';
nicknames.dizzy = 'DZ dizzy 笛子';
nicknames.dominiel = '冰兔';
nicknames.elena = '水琴';
nicknames['elphelt-valentine'] = '火兔 兔枪 兔槍';
nicknames.elson = '光正太';
nicknames['faithless-lidica'] = 'f.lidica flidica 光弓 光高潮';
nicknames['falconer-kluri'] = 'f.kluri fkluri 鹰盾 鸟盾 鷹盾 鳥盾';
nicknames['fallen-cecilia'] = 'f.cc fcc 暗龙 暗龍';
nicknames['fighter-maya'] = 'f.maya fmaya 光玛雅 光瑪雅';
nicknames.furious = '开水哥 開水哥';
nicknames['general-purrgis'] = 'g.purrgis gpurrgis gp 光狗 狗大将 狗大將';
nicknames.gloomyrain = '光爪';
nicknames['guider-aither'] = '光王子';
nicknames.gunther = '昆特大爷 坤哥';
nicknames.haste = '火正太';
nicknames.helga = '三星小木斧';
nicknames['holiday-yufine'] = '烧烤龙 喷火龙 火龙妹 包子龙 燒烤龍 噴火龍 火龍妹 包子龍';
nicknames.hurado = '光头 三星暗法 光頭';
nicknames.iseria = '木飞剑 木飛劍';
nicknames.jecht = '木狗奶';
nicknames['judge-kise'] = 'j.kise jkise 光绮世 光74 光镰刀 光綺世 光鐮刀';
nicknames.judith = '小火刺';
nicknames.kawerik = '威哥';
nicknames.kayron = '隆哥 凯宝 凯皇 凱寶 凱皇';
nicknames['kizuna-ai'] = 'ai vtb';
nicknames.ken = '火拳 火肯';
nicknames.khawana = '火妹妹';
nicknames['kikirat-v2'] = '光高达 扎古 光机器人 高達 鋼彈 紮古 機器人';
nicknames.kiris = '毒弓';
nicknames.kise = '水74 新水镰 新水鐮';
nicknames['kitty-clarissa'] = '暗猫 暗貓';
nicknames.krau = '宝马哥 寶馬哥';
nicknames.lena = '水拳';
nicknames.leo = '木弹弓 木彈弓';
nicknames.lidica = '火弓 火高潮 高潮脸 高潮臉';
nicknames.lilias = 'llys 火盾';
nicknames.lilibet = '剪刀 llb 萝莉 蘿莉';
nicknames['little-queen-charlotte'] = 'lqc 光呆毛';
nicknames.lots = '木拉兹 木拉';
nicknames.ludwig = '木正太';
nicknames.luluca = 'llk';
nicknames.luna = '水龙 水龍';
nicknames['maid-chloe'] = 'ml.chloe mlchloe 光锤 光女仆 光錘';
nicknames['martial-artist-ken'] = 'ml.ken mlken 暗拳 暗肯';
nicknames['mascot-hazel'] = '转职火奶 腹黑 学生会 轉職火奶 學生會';
nicknames.maya = '火玛雅 火瑪雅';
nicknames.melissa = '吸血鬼 孕妇 棺材妹 孕婦';
nicknames.mercedes = '女主';
nicknames['mercenary-helga'] = '转职木斧 轉職木斧';
nicknames['mighty-scout'] = '木老鼠';
nicknames.mirsa = '三星小光刺';
nicknames.mistychain = '水爪';
nicknames.mui = '木鞭子 驯兽师 马戏团 馴獸師 馬戲團';
nicknames.pavel = '木枪 木槍';
nicknames.pearlhorizon = '木爪';
nicknames.purrgis = '木狗 反击狗 反擊狗';
nicknames.pyllis = '三星暗盾';
nicknames.ray = '男医生 男醫生';
nicknames.ras = '男主';
nicknames.ravi = '罗飞 羅飛';
nicknames['remnant-violet'] = '暗苹果 暗给 暗gay 暗蘋果 暗給';
nicknames.requiemroar = '暗爪';
nicknames['researcher-carrot'] = '卡罗 转职火法 卡羅 轉職火法';
nicknames['righteous-thief-roozid'] = '木狗 拉条狗 拉條狗';
nicknames.rin = '木02';
nicknames['roaming-warrior-leo'] = '暗弹弓 暗炸弹 暗彈弓 暗炸彈';
nicknames.roana = '木瓜奶';
nicknames.romann = '罗曼 羅曼';
nicknames.rose = '水萝季 水罗 水罗季 水蘿季 水羅 水羅季';
nicknames['ruele-of-light'] = '光瑞儿 光奶 光瑞兒';
nicknames['sage-baal-and-sezan'] = 'ml.baal mlbaal 光三眼 光人偶';
nicknames.schuri = '火枪 火修 火槍';
nicknames['shooting-star-achates'] = 'ssa 暗奶 暗火奶';
nicknames['seaside-bellona'] = 'ssb 水扇';
nicknames.serila = '火南瓜';
nicknames.sez = '水刺';
nicknames['shadow-rose'] = '暗萝季 暗罗季 暗蘿季 暗羅季';
nicknames.sigret = '旧水镰 眼镜姐 舊水鐮 眼鏡姐';
nicknames.silk = '木席可';
nicknames['silver-blade-aramintha'] = 'ml.aramintha mlaramintha 光响指 光法 光響指';
nicknames['sinful-angelica'] = 'ml.angelica mlangelica 暗水奶 暗奶';
nicknames['specimen-sez'] = 'ml.sez mlsez 光刺 光弟弟';
nicknames['specter-tenebria'] = 's.tene stene ml.tenebria mltenebria 暗法 暗泰妮';
nicknames.surin = '苏林 蘇林';
nicknames.sven = '屎兵';
nicknames.tamarinne = '偶像';
nicknames['taranor-guard'] = 'tg 水桶';
nicknames['taranor-royal-guard'] = '反击水桶 反伤盾 反擊水桶 反傷盾';
nicknames['temmpest-surin'] = '光苏琳 光苏林 光蘇琳 光蘇林';
nicknames.tenebria = '泰妮 火泰妮 旧火法 舊火法';
nicknames.tieria = '三星小火斧';
nicknames['top-model-luluca'] = 'llk 光暗璐璐卡';
nicknames['troublemaker-crozet'] = 'ml.crozet mlcrozet 暗团长 暗團長';
nicknames.vildred = '木刺 25仔';
nicknames.violet = '木给 木gay 木苹果 木給 木蘋果';
nicknames.vivian = 'vva';
nicknames['wanderer-silk'] = 'ml.silk mlsilk 光席可';
nicknames['watcher-schuri'] = '光修里 光修理 光修裏';
nicknames.yufine = '木龙 木龍';
nicknames.yuna = '学生会长 學生會長';
nicknames.zerato = '水杰 冰杰 冰法 水傑 冰傑';
nicknames.belian = 'belian';
// artifacts
nicknames['alexas-basket'] = '大公鸡 大攻击 大公雞 大攻擊';
nicknames.aurius = '分摊 分攤';
nicknames['moonlight-dreamblade'] = '闪避刀 閃避刀';
nicknames['holy-sacrifice'] = '复活 複活';
nicknames['elbris-ritual-sword'] = '大宝剑 大寶劍';
nicknames['proof-of-valor'] = '工会神器 公会神器 工會神器 公會神器';
nicknames['timeless-anchor'] = '船锚 船錨';
nicknames['magarahas-tome'] = '飙车书 飆車書';
nicknames['tagehels-ancient-book'] = '魂书 魂書';
